export default __webpack_public_path__ + "static/media/client_list.26c4268d.jpg";